/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Mitgliedschaftszeitraum1Inputs */

const de__field_mitgliedschaftszeitraum1 = /** @type {(inputs: _Field_Mitgliedschaftszeitraum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitgliedschaftszeitraum`)
};

/**

* @param {_Field_Mitgliedschaftszeitraum1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_mitgliedschaftszeitraum1 = /** @type {((inputs?: _Field_Mitgliedschaftszeitraum1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Mitgliedschaftszeitraum1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_mitgliedschaftszeitraum1(inputs)
});
export { _field_mitgliedschaftszeitraum1 as "_field_Mitgliedschaftszeitraum" }